<template>
  <div class="plv-ia-qn-new-statistics">
    <Loading v-if="loading" />
    <template v-else>
      <div class="plv-ia-qn-new-statistics-content">
        <div class="plv-ia-qn-new-preview-title">
          <p>{{ questionnaire.name }}</p>
        </div>
        <div class="plv-ia-qn-new-preview-introduce">
          <p>{{ questionnaire.desc }}</p>
        </div>
        <!-- 分割线-->
        <div class="plv-ia-qn-new-statistics-dividing"></div>
        <div  v-for="(item,index) in questionnaire.questions" class="plv-ia-qn-new-statistics-list" :key="index">
          <div class="plv-ia-qn-new-question-preview-title" style="align-items: unset;">
            <p :class="{'plv-ia-qn-new-question-preview--required': item.isRequired}" style="flex: 1;">{{ formatTitle(item, index + 1) }} <span class="plv-ia-qn-new-question-color--blue"> {{ formatScore(item) }}</span></p>
            <span
              class="plv-ia-qn-new-statistics-total"
              style="font-weight: normal;"
              v-html="t('plvIA.questionnaire.questionnaireFillingVolume', {total: statisticsMap[item.questionId].total})">
            </span>
          </div>

          <!--  单选，多选-->
          <div v-if="item.type === QUESTION_TYPE.SINGLE || item.type === QUESTION_TYPE.MULTIPLE || item.type === QUESTION_TYPE.JUDGE" class="plv-ia-qn-new-statistics-table">
            <div class="plv-ia-qn-new-statistics-table-header">
              <div class="plv-ia-qn-new-statistics-table-tr">
                <div class="plv-ia-qn-new-statistics-table-td" style="flex: 1;" :title="t('plvIA.questionnaire.optionLabel')">
                  {{t('plvIA.questionnaire.optionLabel')}}
                </div>
                <div class="plv-ia-qn-new-statistics-table-td" :title="t('plvIA.questionnaire.peopleNumLabel')">
                  {{t('plvIA.questionnaire.peopleNumLabel')}}
                </div>
                <div class="plv-ia-qn-new-statistics-table-td" :title="t('plvIA.questionnaire.proportion')">
                  {{t('plvIA.questionnaire.proportion')}}
                </div>
              </div>
            </div>
            <div class="plv-ia-qn-new-statistics-table-body">
              <div v-for="(option, index) in item.options" class="plv-ia-qn-new-statistics-table-tr" :key="index">
                <div class="plv-ia-qn-new-statistics-table-td" style="flex: 1;">
                  <span class="plv-ia-qn-new-statistics-question-option" :title="option"> {{ toUppercaseLetter(index) }}. {{ option }} </span>
                  <span v-if="isCorrect(item, index)" class="plv-ia-qn-new-question-color--blue" style="margin-left: 10px;">({{t('plvIA.questionnaire.correctAnswer')}})</span>
                </div>
                <div class="plv-ia-qn-new-statistics-table-td">
                  {{ getOption(item.questionId, index) }}
                </div>
                <div class="plv-ia-qn-new-statistics-table-td">
                  {{ getOptionPercentageStr(item.questionId, index) }}
                </div>
              </div>
            </div>
          </div>
          <!-- 评星题 -->
          <div v-else-if="item.type === QUESTION_TYPE.STAR || item.type === QUESTION_TYPE.STAR_NUMBER" class="plv-ia-qn-new-statistics-table">
            <div class="plv-ia-qn-new-statistics-table-header">
              <div class="plv-ia-qn-new-statistics-table-tr plv-ia-qn-new-statistics-table-tr--between">
                <div class="plv-ia-qn-new-statistics-table-td">
                  选项
                </div>
                <div class="plv-ia-qn-new-statistics-table-td">
                  人数
                </div>
                <div class="plv-ia-qn-new-statistics-table-td">
                  占比
                </div>
              </div>
            </div>
            <div class="plv-ia-qn-new-statistics-table-body">
              <template v-if="item.type === QUESTION_TYPE.STAR">
                <div v-for="index in 5" class="plv-ia-qn-new-statistics-table-tr plv-ia-qn-new-statistics-table-tr--between" :key="index">
                  <div class="plv-ia-qn-new-statistics-table-td" style="flex: 1;">
                    <star :max-star="index" :value="index" disabled/>
                  </div>
                  <div class="plv-ia-qn-new-statistics-table-td">
                    {{ getOption(item.questionId, index -1) }}
                  </div>
                  <div class="plv-ia-qn-new-statistics-table-td">
                    {{ getOptionPercentageStr(item.questionId, index - 1) }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-for="index in 10" class="plv-ia-qn-new-statistics-table-tr plv-ia-qn-new-statistics-table-tr--between" :key="index">
                  <div class="plv-ia-qn-new-statistics-table-td">
                    {{ index }}分
                  </div>
                  <div class="plv-ia-qn-new-statistics-table-td">
                    {{ getOption(item.questionId, index -1) }}
                  </div>
                  <div class="plv-ia-qn-new-statistics-table-td">
                    {{ getOptionPercentageStr(item.questionId, index - 1) }}
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div v-else-if="item.type === QUESTION_TYPE.TEXT" class="plv-ia-qn-new-statistics-table">
            <div class="plv-ia-qn-new-statistics-table-header">
              <div class="plv-ia-qn-new-statistics-table-tr plv-ia-qn-new-statistics-table-tr--between">
                <div class="plv-ia-qn-new-statistics-table-td" style="flex: 1;">
                  <span class="plv-ia-qn-new-statistics-question-type">{{t('plvIA.questionnaire.fillInTheBlank')}}</span>
                  <span class="plv-ia-qn-new-question-icon--tip"></span>
                  <span class="plv-ia-qn-new-statistics-tip">查看结果只展示3条内容，导出数据可查看全部。</span>
                </div>
              </div>
            </div>
            <div class="plv-ia-qn-new-statistics-table-body">
              <div v-for="(answer, index) in statisticsMap[item.questionId].answerList" class="plv-ia-qn-new-statistics-table-tr" :key="index">
                <div class="plv-ia-qn-new-statistics-table-td" style="flex: 1;">
                  <span class="plv-ia-qn-new-statistics-question-option" style="flex: 1; max-width: 580px;" :title="answer">{{ answer }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="plv-ia-qn-new-statistics-bottom">
        <div class="plv-ia-qn-new-statistics-bottom-left">
          <button class="plv-ia-common-btn plv-ia-common-btn-blue" @click="sendResult">{{t('plvIA.questionnaire.sendResultsToParticipants')}}</button>
          <button class="plv-ia-common-btn plv-ia-common-btn-cancel" @click="downloadStatistics">{{t('plvIA.questionnaire.exportDataLabel')}}</button>
          <span class="plv-ia-qn-new-statistics-total" v-html="t('plvIA.questionnaire.questionnaireReceiveCount', {total: questionnaire.statistics.total}) "></span>
        </div>
        <div>
          <button class="plv-ia-common-btn plv-ia-common-btn-cancel" @click="quite">{{t('plvIA.common.back')}}</button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Loading from '../../../components/loading/Loading';
import { QUESTION_TYPE, toLowercaseLetter, toUppercaseLetter, getOptionPercentageStr, STEP } from '@/assets/app/questionnaire/helper';
import star from '../../../components/star/star';
import Locale from '@/mixins/locale';
import commonMixin from '../../app-mixin';
export default {
  name: 'QuestionnaireStatistics',
  props: {
    questionnaireId: {
      type: String,
      required: true
    },
    core: {
      type: Object,
      required: true
    }
  },
  mixins: [Locale, commonMixin],
  components: {
    Loading,
    star
  },
  data() {
    return {
      QUESTION_TYPE,
      questionnaire: {},
      loading: true,
      statisticsMap: {},
    };
  },
  computed: {
  },
  async mounted() {
    this.loading = true;
    try {
      this.questionnaire = await this.core.getQuestionnaireDetail(this.questionnaireId);
      for (const question of this.questionnaire.questions) {
        this.setStatisticsMap(question);
      }
    } catch (error) {
      this.$iaMessage.default(error.message);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    toUppercaseLetter,
    toLowercaseLetter,
    formatTitle(questionData, index) {
      let typeLabel = '';
      if (questionData.type === QUESTION_TYPE.SINGLE) {
        typeLabel = this.t('plvIA.questionnaire.single');
      } else if (questionData.type === QUESTION_TYPE.MULTIPLE) {
        typeLabel = this.t('plvIA.questionnaire.multiple');
      } else if (questionData.type === QUESTION_TYPE.JUDGE) {
        typeLabel = this.t('plvIA.questionnaire.judgement');
      }
      return `${index}.${typeLabel} ${questionData.name}`;
    },
    formatScore(questionData) {
      let scoreLabel = '';
      if (questionData.score) {
        scoreLabel = `[${questionData.score}分]`;
      }
      return scoreLabel;
    },
    setStatisticsMap(item) {
      const { questionId } = item;
      const defaultStatistics = {
        answerList: [],
        total: 0,
      };
      this.statisticsMap[questionId] = this.questionnaire.statistics.questions.find(item => item.questionId === questionId) || defaultStatistics;
    },
    isCorrect(item, index) {
      return item.answer.includes(toLowercaseLetter(index));
    },
    getOption(questionId, index) {
      const { statisticsMap } = this;
      return statisticsMap[questionId].options ? statisticsMap[questionId].options[index] : 0;
    },
    getOptionPercentageStr(questionId, index) {
      return getOptionPercentageStr(this.statisticsMap[questionId], index) || 0;
    },
    quite() {
      this.$emit('change-current-step', STEP.QUESTIONNAIRE_LIST);
    },
    downloadStatistics() {
      this.$emit('download-statistics', this.questionnaireId);
    },
    sendResult() {
      this.$emit('send-result', this.questionnaire);
    }
  }
};
</script>

<style lang="scss">
.plv-ia-qn-new-statistics {
  height: 100%;
  padding-bottom: 80px;
  overflow-y: hidden;
  box-sizing: border-box;
  position: relative;
}
.plv-ia-qn-new-statistics-content {
  overflow-y: auto;
  box-sizing: border-box;
  height: 100%;
  padding: 24px 42px 0;
}
.plv-ia-qn-new-statistics-dividing {
  height: 1px;
  background-color: #E4E9F1;
  margin-top: 20px;
  margin-bottom: 20px;
}
.plv-ia-qn-new-question-total {
  color: var(--interactBlue) !important;
}
.plv-ia-qn-new-statistics-question-option {
  display: inline-block;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.plv-ia-qn-new-statistics-table {
  margin-top: 16px;
  margin-bottom: 25px;
  border: 1px solid #F6F6F6;
  .plv-ia-qn-new-statistics-table-header {
    background-color: #F6F6F6;
    font-weight: bold;
  }
  .plv-ia-qn-new-statistics-table-tr--between {
    justify-content: space-between;
  }
  .plv-ia-qn-new-statistics-table-tr {
    display: flex;
    height: 40px;
    align-items: center;
    font-size: 14px;
    color: #333333;
    padding-left: 20px;
    padding-right: 10px;
    border-bottom: 1px solid #F6F6F6;
    .plv-ia-qn-new-statistics-table-td:first-child {
      text-align: left;
      display: flex;
      align-items: center;
    }
    .plv-ia-qn-new-statistics-table-td {
      width: 60px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      // 超出隐藏
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span {
        display: inline-block;
      }
    }
  }
}
.plv-ia-qn-new-statistics-bottom {
  position: absolute;
  padding: 0 42px;
  left: 0;
  right: 0;
  bottom: 20px;
  display: flex;
  justify-content: space-between;
  .plv-ia-qn-new-statistics-bottom-left {
    .plv-ia-common-btn-cancel {
      margin-left: 16px;
      margin-right: 24px;
    }
    .plv-ia-common-btn-cancel:hover {
      color: var(--interactBlue);
    }
  }
}
.plv-ia-qn-new-statistics-question-type {
  margin-right: 10px;
}
.plv-ia-qn-new-statistics-tip {
  font-size: 12px;
  color: #878787;
}
.plv-ia-qn-new-statistics-total {
  font-size: 14px;
  color: #333333;
  span {
    color: var(--interactBlue);
  }
}
</style>
